import { __assign, __read } from "tslib";
import { getCustomPivotSettingKey, LayoutPreferenceSettingKey, } from '@office-start/base-edgeworth-control';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { logGenericEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logFeature, logUserAction } from '@office-start/telemetry-service';
import { useCallback, useMemo } from 'react';
import { getFilteredCustomPivotKey } from '../getFilteredCustomPivotKey';
export function useQuickAccessCallbacks(_a) {
    var edgeworthCallbacks = _a.edgeworthCallbacks, upsertMutation = _a.upsertMutation, deleteMutation = _a.deleteMutation;
    var context = useOfficeComponentContext().data;
    var _b = __read(upsertMutation, 1), addSetting = _b[0];
    var _c = __read(deleteMutation, 1), removeSetting = _c[0];
    var onAddCustomPivot = useCallback(function (customFilterType, filterKey) {
        var _a;
        var params = (_a = {},
            _a['State'] = getFilteredCustomPivotKey(customFilterType, filterKey),
            _a);
        logGenericEvent(KnownInstrumentationEvents.QuickAccessCreateCustomPivot, params);
        //TODO: Remove above Aria logging after fully migrating to OTEL
        logUserAction({
            id: 'QuickAccessCreateCustomPivot',
            area: 'QuickAccess',
            result: 'Create',
            target: 'QuickAccess',
            eventName: 'QuickAccessCreateCustomPivot',
        });
        logFeature({
            featureName: "QuickAccess" /* KnownFeatureNames.QuickAccess */,
            eventName: 'QuickAccessCreateCustomPivot',
            params: params,
        });
        addSetting({
            name: getCustomPivotSettingKey(customFilterType, filterKey),
            value: filterKey,
        });
    }, [addSetting]);
    var onRemoveCustomPivot = useCallback(function (customFilterType, filterKey) {
        var _a;
        var params = (_a = {},
            _a['State'] = getFilteredCustomPivotKey(customFilterType, filterKey),
            _a);
        logGenericEvent(KnownInstrumentationEvents.QuickAccessRemoveCustomPivot, params);
        //TODO: Remove above Aria logging after fully migrating to OTEL
        logUserAction({
            id: 'QuickAccessRemoveCustomPivot',
            area: 'QuickAccess',
            result: 'Delete',
            target: 'QuickAccess',
            eventName: 'QuickAccessRemoveCustomPivot',
        });
        logFeature({
            featureName: "QuickAccess" /* KnownFeatureNames.QuickAccess */,
            eventName: 'QuickAccessRemoveCustomPivot',
            params: params,
        });
        removeSetting({
            name: getCustomPivotSettingKey(customFilterType, filterKey),
            value: filterKey,
        });
    }, [removeSetting]);
    var onChangeLayout = useCallback(function (layoutOption) {
        var _a;
        var layoutString = layoutOption.toString();
        var params = (_a = {},
            _a['State'] = layoutString,
            _a);
        logGenericEvent(KnownInstrumentationEvents.QuickAccessChangeLayout, params);
        //TODO: Remove above Aria logging after fully migrating to OTEL
        logUserAction({
            id: 'QuickAccessChangeLayout',
            area: 'QuickAccess',
            result: 'Toggle',
            target: 'QuickAccess',
        });
        logFeature({
            featureName: "QuickAccess" /* KnownFeatureNames.QuickAccess */,
            eventName: 'QuickAccessChangeLayout',
            params: params,
            area: 'QuickAccess',
        });
        addSetting({
            name: LayoutPreferenceSettingKey,
            value: layoutString,
        });
    }, [addSetting]);
    var onShowCustomPivotsMenu = useCallback(function () {
        logGenericEvent(KnownInstrumentationEvents.QuickAccessShowCustomPivotsMenu);
        //TODO: Remove above Aria logging after fully migrating to OTEL
        logUserAction({
            id: 'QuickAccessShowCustomPivotsMenu',
            area: 'QuickAccess',
            result: 'ShowMore',
            target: 'QuickAccess',
        });
    }, []);
    var onDocumentClick = useCallback(function (item, index, event) {
        var _a, _b;
        (_a = edgeworthCallbacks.onDocumentClick) === null || _a === void 0 ? void 0 : _a.call(edgeworthCallbacks, item, index, event);
        (_b = context === null || context === void 0 ? void 0 : context.recordFloodgate) === null || _b === void 0 ? void 0 : _b.call(context, ['ClickedOnDocument']);
    }, [context, edgeworthCallbacks]);
    return useMemo(function () { return (__assign(__assign({}, edgeworthCallbacks), { onDocumentClick: onDocumentClick, onAddCustomPivot: onAddCustomPivot, onRemoveCustomPivot: onRemoveCustomPivot, onChangeLayout: onChangeLayout, onShowCustomPivotsMenu: onShowCustomPivotsMenu })); }, [
        edgeworthCallbacks,
        onDocumentClick,
        onAddCustomPivot,
        onChangeLayout,
        onRemoveCustomPivot,
        onShowCustomPivotsMenu,
    ]);
}
//# sourceMappingURL=useQuickAccessCallbacks.js.map